import React from 'react';
import { Redirect } from 'react-router-dom';
import { useSelector } from 'react-redux';
import '../nurturer-auth/styles/auth.css';
import AuthShell from '../nurturer-auth/components/AuthShell';
import AuthPageBrand from '../nurturer-auth/components/AuthPageBrand';
import { forgotAside } from '../nurturer-auth/components/authAsides';
import ForgotPasswordForm from '../nurturer-auth/forms/ForgotPasswordForm';

function ForgotPassword() {
  const { isAuth } = useSelector((state) => state.login);

  if (isAuth) {
    return <Redirect to="/apps/dashboard" />;
  }

  return (
    <AuthShell aside={forgotAside}>
      <AuthPageBrand />
      <div className="auth-head">
        <h1>
          Reset your <em>password</em>
        </h1>
        <p>Enter the email on your account and we&apos;ll send a secure reset link.</p>
      </div>
      <ForgotPasswordForm />
    </AuthShell>
  );
}

export default ForgotPassword;
